'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (components, getState, dispatch, location, params, deferred) {
  var methodName = deferred ? 'fetchDataDeferred' : 'fetchData';

  return components.filter(function (component) {
    return component && component[methodName];
  }) // only look at ones with a static fetchData()
  .map(function (component) {
    return component[methodName];
  }) // pull out fetch data methods
  .map(function (fetchData) {
    return fetchData(getState, dispatch, location, params);
  }); // call fetch data methods and save promises
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/getDataDependencies.js
// module id = 1108
// module chunks = 0